<template>
  <b-card no-body>
    <b-card-header>
      <b-row>
        <b-col md="6">
          <h3 class="mb-0" v-if="subscription">
            Subscription: {{ subscription.name }}
          </h3>
        </b-col>
        <b-col md="6">
          <b-button :to="'/subscriptions/'" variant="danger" class="float-right" v-if="!grandfathered">Change Subscription</b-button>
        </b-col>
      </b-row>
    </b-card-header>
    <div class="card-body">
      <strong>Invoices:</strong>
    </div>

    <b-table responsive id="invoices" small :items="invoices" :fields="fields" v-if="invoices">
      <template #cell(actions)="row">
        <a :href="row.item.pdf" class="btn btn-sm btn-danger" target="_blank">Download</a>
      </template>
    </b-table>
    <loading-panel v-else></loading-panel>
  </b-card>
</template>

<script>
import axios from 'axios';
import LoadingPanel from '@/components/LoadingPanel';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel
  },
  data: function() {
    return {
      subscription: null,
      invoices: null,
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'date'
        },
        {
          key: 'total'
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      loading_invoices: true
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    grandfathered() {
      return this.$store.getters['profile/grandfathered'];
    }
  },
  methods: {
    async getSubscription() {
      await axios.get(this.userRoute + '/subscription')
      .then(response => {
        this.subscription = response.data
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getInvoices() {
      axios.get(this.userRoute + "/invoices")
        .then(response => {
          this.loading_invoices = false;
          this.invoices = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    }
  },
  created() {
    this.getSubscription();
    this.getInvoices();
  },
};
</script>